// SINGLE SOURCE OF TRUTH for the "add-child template trap".
//
// `new_child_fields_template` (app/helpers/application_helper.rb) renders every
// "Add a trade-in / cobuyer / commission / deferred-down / form-field / …" template
// as a HIDDEN `<div class="outer_container" style="display:none">` that sits INSIDE a
// form's `data-controller="…"` scope. If any widget layer (Stimulus *TargetConnected,
// the app-wide date-input hook, a MutationObserver, …) initializes the widgets in that
// hidden markup, `add_child` (deal.js / inventory.js) then clones the ALREADY-mangled
// HTML — so the inserted row's Choices dropdown / flatpickr date / etc. can never
// initialize (the recurring "payoff Vendor / cobuyer contact / cost date shows a
// placeholder but never opens" class of bug).
//
// The fix is a CONTRACT that EVERY widget-init path funnels through this one predicate:
// never initialize a widget that lives inside template markup. Because the check lives
// in exactly one place and is imported by every path (the Stimulus choices/flatpickr/
// tinymce controllers AND the universal widget_init layer), a NEW widget or a NEW nested
// section can't reintroduce the bug — it inherits the guard for free.
//
// Two forms of inert template markup are honored:
//   1. `.outer_container` — the hidden add-child template div (current convention). The
//      cloned+inserted copy has NO `.outer_container` ancestor, so it initializes normally.
//      Server-rendered saved rows aren't inside `.outer_container` either, so they too
//      initialize.
//   2. a real `<template>` element — its content is inert by the HTML spec (never in the
//      live DOM), so observers never even see it; honored here so that if any form is
//      later migrated to a real `<template>`, this layer keeps behaving correctly.
export function isInertTemplate(el) {
  if (!el || typeof el.closest !== 'function') return false
  return !!(el.closest('.outer_container') || el.closest('template'))
}
